import { getBreadcrumbs } from 'client/store/config/reducer'
import { useSelector } from 'react-redux'
import { Breadcrumb, Breadcrumbs } from '@vp/swan'
import { useTranslations } from '~/client/hooks/useTranslations'
import { UBIK_TRACKING_BREADCRUMBS_LABEL, UBIK_TRACKING_LINK_ATTRIBUTES } from '~/client/components/Gallery/Header/BreadcrumbsContainer/constants'

export const BreadcrumbsContainer = () => {
  const breadcrumbs = useSelector(getBreadcrumbs)
  const localize = useTranslations()

  return (
    <Breadcrumbs
      accessibleTextForMore={localize('BreadcrumbsMoreAccessibleText')}
      aria-label="breadcrumbs"
      data-ubik-event-data-page-zone={UBIK_TRACKING_BREADCRUMBS_LABEL}
      data-ubik-event-data-label={UBIK_TRACKING_BREADCRUMBS_LABEL}
    >
      {breadcrumbs?.map((breadcrumb) => (
        <Breadcrumb key={breadcrumb.position}>
          <a href={breadcrumb.url} {...UBIK_TRACKING_LINK_ATTRIBUTES} data-ubik-event-data-cta-value={breadcrumb.ctaValue}>
            {breadcrumb.name}
          </a>
        </Breadcrumb>
      ))}
    </Breadcrumbs>
  )
}

BreadcrumbsContainer.displayName = 'BreadcrumbsContainer'
